import {api} from "./api";
import {Notifications} from "./notifications";

export class ImageUpload {

    constructor() {
        this.event = new Event('modal.loaded');
    }

    static getPlaceholder() {
        let placeholderElement = document.querySelector("#modal-placeholder");

        if (!placeholderElement) {
            placeholderElement = document.createElement('div');
            placeholderElement.id = "modal-placeholder";

            document.body.appendChild(placeholderElement);
        }

        return placeholderElement;
    }

    static init() {
        document.querySelectorAll("input[data-toggle=\"upload-image\"]").forEach((el) => {
            el.addEventListener("change", async (e) => {
                const placeholderElement = this.getPlaceholder();
                let cropper;

                const uploadUrl = el.dataset.url;
                const messageTitle = el.dataset.messageTitle;
                const successMessage = el.dataset.successMessage;
                const previewClass = el.dataset.previewClass;
                const imageWidth = el.dataset.imageWidth ?? 400;
                const imageHeight = el.dataset.imageHeight ?? 400;
                const aspectRatio = el.dataset.aspectRatio ?? 1;
                const urlInput = el.dataset.urlInput;

                const {data} = await axios.get("/uploadimage/");

                const modalHtml = new DOMParser().parseFromString(data, 'text/html');
                placeholderElement.append(...modalHtml.body.children);
                const modalEl = placeholderElement.querySelector(".modal");

                const modal = new bootstrap.Modal(modalEl);

                modalEl.addEventListener('show.bs.modal', e => {
                    cropper = new Cropper(document.getElementById('image'), {
                        aspectRatio: aspectRatio,
                        dragMode: 'move',
                        cropBoxMovable: false,
                        cropBoxResizable: false,
                        minContainerWidth: 300,
                        minContainerHeight: 300,
                        minCanvasWidth: 0,
                        minCropBoxWidth: 250,
                        autoCropArea: 0.9,
                        viewMode: 0,
                    });

                    let buttons = document.getElementById('cropper-buttons');
                    let methods = buttons.querySelectorAll('[data-method]');
                    methods.forEach(function (button) {
                        button.addEventListener('click', function (e) {
                            let method = button.getAttribute('data-method');
                            let option = button.getAttribute('data-option');
                            let option2 = button.getAttribute('data-second-option');

                            let result;
                            if (option2) {
                                result = cropper[method](option, option2);
                            } else if (option) {
                                result = cropper[method](option);
                            } else {
                                result = cropper[method]();
                            }

                            if (method === 'getCroppedCanvas') {
                                const modal = document.getElementById('getCroppedCanvasModal');
                                const modalBody = modal.querySelector('.modal-body');
                                modalBody.innerHTML = '';
                                modalBody.appendChild(result);
                            }

                            const input = document.querySelector('#putData');
                            try {
                                input.value = JSON.stringify(result);
                            } catch (e) {
                                if (!result) {
                                    input.value = result;
                                }
                            }
                        });
                    });
                });

                modalEl.addEventListener('hide.bs.modal', e => {
                    cropper.destroy();
                    cropper = null;

                    placeholderElement.innerHTML = "";
                });

                const cropButton = placeholderElement.querySelector("#crop");
                cropButton.addEventListener("click", async e => {
                    e.preventDefault();
                    cropButton.setAttribute("data-kt-indicator", "on");
                    cropButton.setAttribute("disabled", "disabled");

                    let canvas;
                    if (cropper) {
                        let imageData = cropper.getImageData();
                        canvas = cropper.getCroppedCanvas({
                            width: imageWidth,
                            height: imageHeight,
                            maxWidth: imageData.naturalWidth,
                            maxHeight: imageData.naturalHeight,
                            imageSmoothingQuality: 'high'
                        });

                        document.querySelectorAll(`.${previewClass}`).forEach(el => {
                            el.removeAttribute("srcset");
                            el.setAttribute("src", canvas.toDataURL());
                            el.removeAttribute("style");
                        });

                        canvas.toBlob(async blob => {
                            let formData = new FormData();
                            formData.append('upload', blob, file.name);

                            try {
                                const {data} = await api.post(uploadUrl, formData);
                                Notifications.showSuccess({ message: successMessage });

                                if (urlInput && data.url)
                                    document.getElementById(urlInput).value = data.url;

                            } catch {
                                Notifications.showError({ message: "There was an error uploading the image." });
                            } finally {
                                modal.hide();
                            }
                        });
                    }
                });

                let done = url => {
                    e.target.value = '';
                    document.getElementById('image').src = url;

                    modal.show();
                };

                const file = e.target.files[0];
                if(file) {
                    if (URL) {
                        done(URL.createObjectURL(file));
                    } else if (FileReader) {
                        const reader = new FileReader();
                        reader.onload = function (e) {
                            done(reader.result);
                        };
                        reader.readAsDataURL(file);
                    }
                }
            });
        });
    }

}
